module.exports = __webpack_public_path__ + "media/site/images/products/avisboard-flat-screen2-de4a56ff9d4c2140342ecf23a0eff637.png";